import { render, staticRenderFns } from "./CloverResponse.vue?vue&type=template&id=1ff4f16c&scoped=true"
import script from "./CloverResponse.vue?vue&type=script&lang=js"
export * from "./CloverResponse.vue?vue&type=script&lang=js"
import style0 from "./CloverResponse.vue?vue&type=style&index=0&id=1ff4f16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4f16c",
  null
  
)

export default component.exports